import { render, staticRenderFns } from "./ExpirationsView.vue?vue&type=template&id=37d54fee&"
import script from "./ExpirationsView.vue?vue&type=script&lang=js&"
export * from "./ExpirationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports